import { NavLink } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { cn } from '@/lib/classNames';

interface NavItem {
  to: string;
  label: string;
  icon: string; // bootstrap-icons class
  end?: boolean;
}

/**
 * Fixed left sidebar — same nav items, order, and placement as the live AST
 * app (index.php header), modernized: leading icons, rounded hover/active
 * states, role-gated Admin (role 2), and a Logout action pinned to the bottom.
 */
export function Sidebar() {
  const { user, logout } = useAuth();

  const items: NavItem[] = [
    { to: '/', label: 'Home', icon: 'bi-house', end: true },
    { to: '/cpls', label: 'Closing Protection Letters', icon: 'bi-envelope-open' },
    { to: '/jackets', label: 'Jackets', icon: 'bi-folder2-open' },
    { to: '/rate', label: 'Rate Calculator', icon: 'bi-calculator' },
    { to: '/account', label: 'Account', icon: 'bi-person' },
  ];
  if (user?.role === 2) items.push({ to: '/admin', label: 'Admin', icon: 'bi-people' });

  return (
    <div className="ast-header">
      <div className="ast-header-logo" aria-label="American Security Title" />
      <nav className="ast-header-function">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              cn('ast-header-function-button', isActive && 'active')
            }
          >
            <i className={cn('bi', item.icon, 'ast-nav-icon')} aria-hidden="true" />
            <span>{item.label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          className="ast-header-function-button ast-logout"
          onClick={() => void logout()}
        >
          <i className="bi bi-box-arrow-right ast-nav-icon" aria-hidden="true" />
          <span>Logout</span>
        </button>
      </nav>
    </div>
  );
}
